<template>
    <el-button type="primary">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </el-button>
</template>

<script>
  export default {
    name: 'AppSpinner',
  };
</script>

<style scoped>
    .spinner {
        text-align: center;
    }

    .spinner > div {
        width: 10px;
        height: 10px;
        background-color: #ffffff;

        border-radius: 100%;
        display: inline-block;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
        animation-delay: -0.32s;
    }

    .spinner .bounce2 {
        animation-delay: -0.16s;
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1.0);
        }
    }
</style>
